module.exports = __webpack_public_path__ + "static/img/edit.f7d7a19c.png";